import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@app/shared';
import { CoreModule } from '@app/core';
import {
  MatIconModule,
  MatDatepickerModule,
  MatTabsModule,
  MatSnackBarModule,
  MatSlideToggleModule,
  MatProgressSpinnerModule,
  MatProgressBarModule
} from '@angular/material';
import { DateFnsModule } from 'ngx-date-fns';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MomentModule } from 'ngx-moment';
import { VouchersRoutingModule } from '../vouchers-routing.module';
import { VouchersOrdersComponent } from './vouchers-orders.component';
import { SatNativeDateModule, SatDatepickerModule } from 'saturn-datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexModule } from '@angular/flex-layout';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ChangeEmailAddressComponent } from '../vouchers-orders/change-email-address/change-email-address.component';
import { ChangeVoucherPostCodes } from '../vouchers-orders/change-voucher-post-codes/change-voucher-post-codes.component';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    CoreModule,
    SharedModule,
    VouchersRoutingModule,
    MatIconModule,
    NgScrollbarModule,
    NgxDatatableModule,
    MomentModule,
    NgxDatatableModule,
    SatDatepickerModule,
    SatNativeDateModule,
    MatDatepickerModule,
    MatTabsModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    NgSelectModule,
    FormsModule,
    FlexModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    DateFnsModule.forRoot()
  ],
  declarations: [VouchersOrdersComponent, ChangeEmailAddressComponent, ChangeVoucherPostCodes],
  entryComponents: [ChangeEmailAddressComponent, ChangeVoucherPostCodes]
})
export class VouchersOrdersModule {}
